"use strict";
export class BaseCsvParser {
  /**
   * Parse CSV text into an array of objects
   * @param csvText The CSV text to parse
   * @returns An array of objects parsed from the CSV
   */
  parseCSV(csvText) {
    if (!csvText || typeof csvText !== "string") {
      console.error("Invalid CSV text:", csvText);
      return [];
    }
    const lines = csvText.split("\n");
    if (lines.length === 0 || !lines[0]) {
      console.error("CSV has no lines or first line is empty");
      return [];
    }
    const headers = lines[0].split(",").map((header) => header.trim());
    const requiredColumns = this.getRequiredColumns();
    const missingColumns = requiredColumns.filter((col) => !headers.includes(col));
    if (missingColumns.length > 0) {
      console.error(`CSV format missing required columns: ${missingColumns.join(", ")}`, headers);
      return [];
    }
    const result = [];
    for (let i = 1; i < lines.length; i++) {
      if (!lines[i].trim()) continue;
      const values = lines[i].split(",").map((value) => value.trim());
      const record = {};
      headers.forEach((header, index) => {
        if (index < values.length) {
          record[header] = values[index];
        } else {
          record[header] = "";
        }
      });
      if (this.validateRecord(record)) {
        const recordObject = this.createRecordObject(record, headers);
        result.push(recordObject);
      }
    }
    return result;
  }
}
